import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { MicroserviceRequest } from '../../../utils/request/microservice.request';
import { InitGenericDashboardResponse } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';
import { getRequestDefaultOptions } from '../../../utils/request.utils';

export class GzDashboardsAppNirvanaDataProvider extends BaseWebComponentDataProvider {
  async computeUserConfigForDashboard(request: any): Promise<InitGenericDashboardResponse> {
    const requestOptions = getRequestDefaultOptions();
    requestOptions.requestTimeout = 3 * 60000;

    return await MicroserviceRequest.makeRequest('GenericDashboards', 'computeUserConfigForDashboard', request, requestOptions);
  }
}
